var React = require('react');

function PrevLg (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("title",{"key":1},"Asset 4300ppi"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"prev"},React.createElement("path",{"className":"media-control-lg","d":"M1.68,56.83a9.23,9.23,0,0,0,2.57,2.49L37.66,79.49,71,99.68a8.31,8.31,0,0,0,12.28-8l.05-35.38c.1.16.2.32.31.48a9.23,9.23,0,0,0,2.57,2.49l33.41,20.17L153,99.68a8.31,8.31,0,0,0,12.28-8l.06-41.37.17-41.63A8.26,8.26,0,0,0,153,1.19l-34.3,21.44L86,43.83a9.13,9.13,0,0,0-2.61,2.76l.15-37.86A8.26,8.26,0,0,0,71,1.19L36.73,22.63,4,43.83A9.34,9.34,0,0,0,1.68,56.83Z"})))]);
}

PrevLg.defaultProps = {"width":"30px","height":"30px","viewBox":"0 0 165.56 100.72"};

module.exports = PrevLg;

PrevLg.default = PrevLg;
